import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Ref from "csi/heading/Ref";
import TextWithMaterialIcon from "csi/widget/TextWithMaterialIcon";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import { getIconParameters, isLockedAndStarted } from "./ProofService";

export = declare(Ref, {
	/**
	 * @override
	 * If on level above ProofTask then display the ProofStage name
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: Element, _params) {
		var value = this._getValue(ctx, h);
		if (value == null) {
			value = ctx.getNodeAttributeValue(xml.ATTR_NAME, true);
			var stageNode = ctx.getNode();

			// check if stageNode exist when displayed in Proof Task Business Object's Attribute Card
			if (!stageNode) {
				return this.inherited(arguments);
			}

			if (isLockedAndStarted(stageNode)) {
				new TextWithMaterialIcon(getIconParameters("Locked", false, false, value))
					.placeAt(refNode);
				return true;
			}

			if (value == null) {
				return false;
			}

			refNode.innerHTML = value;
			return true;
		}

		return this.inherited(arguments);
	},
});
